/** @format */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'homefield-hero-banner',
  templateUrl: './hero-banner.component.html',
  styleUrl: './hero-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldHeroBannerComponent {
  public textColorVariants = {
    dark: 'dark-text',
    light: 'light-text',
  };

  public textBoxPositionVariants = {
    left: 'float-left',
    center: 'float-center',
    right: 'float-right',
    none: 'none',
  };

  @Input()
  textColor = 'light';

  @Input()
  textBoxPosition = 'left';

  @Input()
  textBoxBackground = true;

  @Input()
  headlineIsH1 = false;

  @Input()
  headline = '';

  @Input()
  subhead = '';

  @Input()
  link = '';

  @Input()
  buttonLabel = '';

  @Input()
  altText = '';

  @Input()
  mobileImage: string;

  @Input()
  image: string;

  @Input()
  buttonStyle = 'marketing';

  @Input()
  imageTitle = '';

  @Input()
  dataEm = '';

  @Input()
  legalText = '';

  @Input()
  legalTextLink = '';
}
